export default __webpack_public_path__ + "static/media/postgresql.ace787d1.png";